import { Button, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CreatePlanButtonProps {
  handleCreatePlan: () => void;
}

export default function CreatePlanButton({
  handleCreatePlan,
}: CreatePlanButtonProps) {
  const { t } = useTranslation();
  const { palette } = useTheme();

  return (
    <Button
      onClick={handleCreatePlan}
      sx={{
        backgroundColor: palette.ctaButton.background,
        color: 'primary.contrastText',
        borderRadius: '24px',
        padding: '6px 24px',
        fontSize: '14px',
        fontWeight: 700,
        boxShadow: '8px 6px 24px -9px rgba(136, 136, 136, 1)',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        '&:hover': {
          background: palette.ctaButton.hoverBackground,
        },
      }}
    >
      {t('mediaPlanning.createPlan')}
    </Button>
  );
}
